import classNames from 'classnames';
import styles from './PhotoCollage.module.css';

import Image, {
  Props as ImageProps
} from '../../Atoms/Image';

type Props = {
  images: [
    ImageProps,
    ImageProps,
    ImageProps,
    ImageProps,
    ImageProps,
    ImageProps,
    ImageProps,
    ImageProps,
    ImageProps,
    ImageProps,
    ImageProps,
    ImageProps
  ];
};

function PhotoCollage({ images }: Props) {
  return (
    <div className={styles.body}>
      {images.map((img, i) => (
        <div
          key={images.indexOf(img)}
          className={classNames([
            styles.card,
            styles[`card-${i + 1}`],
            i % 2 && 'hidden md:block'
          ])}
        >
          <Image {...img} cover />
        </div>
      ))}
    </div>
  );
}

export default PhotoCollage;
